import { Box, SvgIcon } from '@mui/material';
import { lightBlue } from '@mui/material/colors';

export const ActiveNoLocationIcon = (props) => {
  return (
    <Box
      sx={{
        width: props.sx?.width || 14,
        height: props.sx?.height || 14,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: lightBlue[600],
        borderRadius: '50%',
      }}
    >
      <SvgIcon {...props}>
        <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.5 5.25C9.19 5.25 9.75 5.81 9.75 6.5C9.75 6.87 9.585 7.195 9.335 7.425L11.15 9.24C11.64 8.31 12 7.34 12 6.5C12 4.565 10.435 3 8.5 3C7.51 3 6.62 3.415 5.98 4.075L7.575 5.67C7.805 5.41 8.13 5.25 8.5 5.25ZM10.685 10.05L8.37 7.735L8.315 7.68L4.135 3.5L3.5 4.135L5.09 5.725C5.035 5.975 5 6.235 5 6.5C5 9.125 8.5 13 8.5 13C8.5 13 9.335 12.075 10.19 10.825L11.865 12.5L12.5 11.865L10.685 10.05Z"
            fill="white"
          />
        </svg>
      </SvgIcon>
    </Box>
  );
};
